<template>
  <h1 class="d-flex justify-center align-center error--text">
    Define you own template in a child component extending this one
  </h1>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  name: 'BaseSummary',
  computed: {
    summary() {
      return this.getSummaryData()
    },
  },
  watch: {
    /**
     * Precisa ser imediato, pois é calculado bom base em dados já informados,
     * de modo que o componente precisa calcular a primeira vez logo que
     * é montado na tela.
     * Obs.: o ponto negativo é que isso gera o trigger de que existem alterações
     * não salvas só de abrir a tela a primeira vez.
     */
    summary: {
      immediate: true,
      handler(newVal) {
        this.setAttendanceSummary(newVal ?? null)
      },
    },
  },
  methods: {
    ...attendanceActionsMap(['setAttendanceSummary']),
    /**
     * Método que deve devolver o JSON com os dados do summary
     */
    getSummaryData() {
      throw new Error('You must implement getSummaryData method in your child component!')
    },
  },
}
</script>
